<form [formGroup]="form" class="flex flex-col gap-(--space-6)">
  <div class="flex flex-col gap-1">
    <label for="unit" class="text-sm font-medium text-[var(--text-color)]">{{ 'graphs.measureConfig.unit' | transloco }}</label>
    <p-select
      inputId="unit"
      formControlName="unit"
      [options]="unitOptions()"
      [loading]="isLoadingUnits()"
      optionLabel="label"
      optionValue="value"
      [placeholder]="'common.placeholders.selectUnit' | transloco"
      appendTo="body"
      class="w-full" />
  </div>

  <div class="flex flex-col gap-1">
    <label for="scaleLabel" class="text-sm font-medium text-[var(--text-color)]">{{
      'graphs.measureConfig.axisLabel' | transloco
    }}</label>
    <input pInputText id="scaleLabel" type="text" formControlName="scaleLabel" class="w-full" />
    @if (sharedAxisInfo(); as info) {
      <div class="text-sm mt-1 text-[var(--text-color-secondary)]">
        <span>{{ info.message }}</span>
        @if (info.labelWillClear) {
          <span class="block">{{ 'graphs.measureConfig.labelWillClear' | transloco }}</span>
        } @else if (info.labelWillChange) {
          <span class="block">
            @if (info.existingLabel) {
              {{ 'graphs.measureConfig.labelWillReplace' | transloco: { label: info.existingLabel } }}
            } @else {
              {{ 'graphs.measureConfig.labelWillApply' | transloco }}
            }
          </span>
        }
      </div>
    }
  </div>

  @if (showPolynomialOptions) {
    <div class="flex gap-(--space-6)">
      <div class="flex items-center gap-(--space-2)">
        <p-toggleSwitch inputId="polynomInferieur" formControlName="polynomInferieur" />
        <label for="polynomInferieur" class="text-sm text-[var(--text-color)]">{{
          'graphs.measureConfig.polynomialLower' | transloco
        }}</label>
      </div>
      <div class="flex items-center gap-(--space-2)">
        <p-toggleSwitch inputId="polynomSuperieur" formControlName="polynomSuperieur" />
        <label for="polynomSuperieur" class="text-sm text-[var(--text-color)]">{{
          'graphs.measureConfig.polynomialUpper' | transloco
        }}</label>
      </div>
    </div>
  }

  <div class="flex items-center gap-(--space-2)">
    <p-toggleSwitch inputId="customScale" formControlName="customScale" />
    <label for="customScale" class="text-sm text-[var(--text-color)]">{{ 'graphs.measureConfig.customScale' | transloco }}</label>
  </div>

  @if (isCustomScale()) {
    <div class="grid grid-cols-2 gap-(--space-4)">
      <div class="flex flex-col gap-1">
        <label for="scaleMin" class="text-sm font-medium text-[var(--text-color)]">{{
          'graphs.measureConfig.scaleMin' | transloco
        }}</label>
        <input
          pInputText
          id="scaleMin"
          type="number"
          formControlName="scaleMin"
          [placeholder]="'common.placeholders.min' | transloco"
          [class]="scaleInputClass()"
          [attr.aria-invalid]="hasScaleError()"
          [attr.aria-describedby]="hasScaleError() ? 'scale-error' : null" />
      </div>
      <div class="flex flex-col gap-1">
        <label for="scaleMax" class="text-sm font-medium text-[var(--text-color)]">{{
          'graphs.measureConfig.scaleMax' | transloco
        }}</label>
        <input
          pInputText
          id="scaleMax"
          type="number"
          formControlName="scaleMax"
          [placeholder]="'common.placeholders.max' | transloco"
          [class]="scaleInputClass()"
          [attr.aria-invalid]="hasScaleError()"
          [attr.aria-describedby]="hasScaleError() ? 'scale-error' : null" />
      </div>
      @if (hasScaleError()) {
        <div id="scale-error" role="alert" class="col-span-2 text-sm text-(color:--p-error-text) font-medium">
          {{ scaleErrorMessage() }}
        </div>
      }
    </div>
  }

  <ces-dialog-footer [submitDisabled]="!isFormValid()" (onSubmit)="onValidate()" (onCancel)="onCancel()">
    <ces-delete-button footer-start [label]="'graphs.measureConfig.removeMeasure' | transloco" icon="close" (onClick)="onRemove()" />
  </ces-dialog-footer>
</form>
